import {  useDispatch, useSelector } from "react-redux"
import { Field, Input, Label } from "../../styles/common"
import { ComponentUpdate, toggleRefreshColor } from "../../store/slices/component"
import { useState } from "react";
import Swal from "sweetalert2";
import { ProductColorAdded } from "../../common/CommonApi";
import { X } from "lucide-react";
import {
  CloseButton,
  HelperText,
  PrimaryButton,
  SecondaryButton,
  SetupBody,
  SetupDialog,
  SetupFooter,
  SetupHeader,
  SetupOverlay
} from "./ProductSetupModal";

export const AddColor = () => {
    const loginData = useSelector((state) => state.auth)
    const dispatch = useDispatch()
    const [form, setForm] = useState({
        color: '',
      });

    const handleSubmit = async (e) => {
      e.preventDefault();
      try {
        let bodyData = {
             color:form.color,
                _id:loginData._id
        }

        let response = await ProductColorAdded(bodyData)
          if (response.data.message === "SUCCESSFULLY_UPDATED") {
                Swal.fire('Color Added.')
                dispatch(toggleRefreshColor());
                dispatch(ComponentUpdate({isColor:false,isProductModelOpen:true}))
            }
      } catch (err) {
        console.error("Error:", err);
      }
    };

      const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;
        setForm((prevForm) => ({
        ...prevForm,
        [name]:
            type === "checkbox"
            ? checked
            : type === "file"
                ? files[0]   // 👈 will store in form.categoryImage
                : name === "sortOrder"
                ? Number(value)
                : value,
        }));
    };

    const closeModal = () => dispatch(ComponentUpdate({isColor:false,isProductModelOpen:true}));

    return (
        <SetupOverlay onClick={closeModal}>
            <SetupDialog onSubmit={handleSubmit} onClick={(e) => e.stopPropagation()}>
                <SetupHeader>
                    <div>
                      <h2>Add Color</h2>
                      <p>Add a reusable color option for product variants.</p>
                    </div>
                    <CloseButton type="button" aria-label="Close add color" onClick={closeModal}>
                      <X size={18} />
                    </CloseButton>
                </SetupHeader>
                <SetupBody>
                <Field>
                    <Label>Color</Label>
                    <Input name="color"
                    value={form.color} 
                    onChange={handleChange} 
                    required
                    />
                    <HelperText>Use a clear color name, for example Black, Ivory, or Navy Blue.</HelperText>
                </Field>
                </SetupBody>
                <SetupFooter>
                  <SecondaryButton type="button" onClick={closeModal}>Cancel</SecondaryButton>
                  <PrimaryButton type="submit">Add Color</PrimaryButton>
                </SetupFooter>
            </SetupDialog>
        </SetupOverlay>
    )
}
